import { Button } from "@mui/material";
import { FC } from "react";
import Cookies from "universal-cookie";

import {
  getAccessToken,
  getRefreshToken,
  JWT_COOKIE_NAME,
  Log,
  setAccessToken,
  setRefreshToken,
} from "@ryde/shared";

import { CookiesPanelWrapper } from "./controls.panels.styled";

export const CookiesMovePanel: FC = () => {
  const moveCookies = (keepRefreshToken: boolean): void => {
    const token = getAccessToken();
    const refreshToken = getRefreshToken();
    const cookies = new Cookies();

    if (token) {
      Log.debug("Jwt access token found, setting valid token to cookies");
      cookies.set(JWT_COOKIE_NAME, token);
    }

    if (refreshToken) {
      Log.debug("Jwt refresh token found, setting valid cookie");
    }

    setAccessToken(null);

    if (!keepRefreshToken) {
      setRefreshToken(null);
    }

    Log.info("Tokens moved to cookies");
  };

  const moveInvalidToken = (): void => {
    const cookies = new Cookies();
    cookies.set(JWT_COOKIE_NAME, "invalid-token-string");
    setAccessToken(null);
    setRefreshToken(null);

    Log.info("Invalid token set to cookies");
  };

  const accessTokenExists = !!getAccessToken();
  const refreshTokenExists = !!getRefreshToken();
  const cookieExists = !!new Cookies().get(JWT_COOKIE_NAME);

  return (
    <CookiesPanelWrapper>
      <p>Access Token Exists: {accessTokenExists ? "Yes" : "No"}</p>
      <p>Refresh Token Exists: {refreshTokenExists ? "Yes" : "No"}</p>
      <p>Cookie Exists: {cookieExists ? "Yes" : "No"}</p>

      <Button
        onClick={() => moveCookies(false)}
        variant="contained"
        color="primary"
      >
        Move jwt to cookies (cleanup access+refresh tokens)
      </Button>
      <Button
        onClick={() => moveCookies(true)}
        variant="contained"
        color="info"
      >
        Move jwt to cookies (cleanup access, keep refresh tokens)
      </Button>
      <Button onClick={moveInvalidToken} variant="contained" color="secondary">
        Move to cookies invalid token
      </Button>
    </CookiesPanelWrapper>
  );
};
